import React, { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import ProductImageSelect from '../../../../common/Form/FormFields/ProductImageSelect/ProductImageSelect';
import useCartModelDisplay from '../../../../../hooks/useCartModelDisplay';
import Product from '../../../../../@types/Product';

interface CartProductBatteryProps {
  retailConfigurator: boolean,
  hideAllPrices: boolean
}

const CartProductBattery: FC<CartProductBatteryProps> = ({ retailConfigurator, hideAllPrices }) => {
  const { setValue, watch, getValues } = useFormContext();
  const currentCart = getValues();
  const editable = currentCart?.isFromInventory
      ? (currentCart?.chassisBatteryEditable ?? false)
      : true;
  const { chassisType } = useCartModelDisplay();
  const chassisBatteryConfig: Product | undefined = watch('chassisBatteryConfig');

  useEffect(() => {
    setValue('chassisBattery', chassisBatteryConfig?.linkedProducts
      ? chassisBatteryConfig.linkedProducts[0]
      : undefined)
  }, [
    chassisBatteryConfig,
    setValue
  ]);

  return (
    <ProductImageSelect
      name="chassisBatteryConfig"
      label="Chassis Battery"
      displayLabel={false}
      disabled={!editable}
      displayPrice={!hideAllPrices}
      displayRetailPrice={retailConfigurator}
      disableImageZoom={true}
      productAlignment='left'
      products={chassisType?.chassisBatteryConfigOptions ?? []} />
  );
}

export default CartProductBattery;
